module.exports = __webpack_public_path__ + "img/chengliangliu.0da9ded2.jpg";